const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const resolveUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('r2/')) return `${BACKEND}/api/images/${url}`;
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  return url;
};

export const fmtDate = (s, lang = 'en') => {
  if (!s) return '—';
  const locale = lang === 'pl' ? 'pl-PL' : lang === 'de' ? 'de-DE' : 'en-US';
  try {
    return new Date(s).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return s;
  }
};

export const fmtMonthYear = (s, lang = 'en') => {
  if (!s) return '—';
  const locale = lang === 'pl' ? 'pl-PL' : lang === 'de' ? 'de-DE' : 'en-US';
  try {
    return new Date(s).toLocaleDateString(locale, { month: 'long', year: 'numeric' });
  } catch {
    return s;
  }
};

export const fmtDateTime = (s, lang = 'en') => {
  if (!s) return '—';
  const locale = lang === 'pl' ? 'pl-PL' : lang === 'de' ? 'de-DE' : 'en-US';
  try {
    return new Date(s).toLocaleDateString(locale, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch {
    return s;
  }
};

export const initials = (name) => {
  const parts = (name || '').trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '·';
};

export const quietBtn = {
  background: 'transparent', border: 'none', padding: 0, cursor: 'pointer',
  fontFamily: 'Playfair Display, serif', fontSize: 10, letterSpacing: '0.18em',
  textTransform: 'uppercase', color: 'var(--kahla-text-light)',
};

export const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(42,42,42,0.45)', zIndex: 2500,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
};

export const modalStyle = {
  background: 'var(--kahla-cream-light, #faf8f5)', maxWidth: 640, width: '100%',
  maxHeight: '88vh', overflowY: 'auto', padding: '36px 40px',
  boxShadow: '0 8px 48px rgba(0,0,0,0.18)',
};

export const inputStyle = {
  width: '100%', padding: '10px 12px', border: '1px solid var(--kahla-border)',
  background: '#fff', fontFamily: 'inherit', fontSize: 14, color: 'var(--kahla-charcoal)',
  outline: 'none', boxSizing: 'border-box',
};

export const labelStyle = {
  display: 'block', fontFamily: 'Playfair Display, serif', fontSize: 10,
  letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--kahla-text-light)',
  margin: '0 0 6px',
};
